/** Critical latin subsets — preloaded before paint to avoid layout shift. */
export const ELVA_CRITICAL_FONT_PRELOADS = [
  {
    href: '/fonts/inter-tight-latin.woff2',
    file: 'e58b20a0-2ea6-41c1-96d3-2b5c7c7d1a05.woff2',
  },
  {
    href: '/fonts/jetbrains-mono-latin.woff2',
    file: '08887cb8-04d7-496f-91e5-5c49102c8aba.woff2',
  },
] as const;

/** Hide body until fonts are ready; fallback reveal after 4s. */
export const ELVA_FONT_SHELL_CSS = `
html:not(.fonts-ready) body {
  visibility: hidden;
}
html:not(.fonts-ready) body {
  animation: elva-reveal-body 0s 4s forwards;
}
@keyframes elva-reveal-body {
  to {
    visibility: visible;
  }
}
`.trim();

export const ELVA_CRITICAL_FONT_SPECS = [
  '400 16px "Inter Tight"',
  '500 16px "Inter Tight"',
  '600 16px "Inter Tight"',
  '700 16px "Inter Tight"',
  '400 13px "JetBrains Mono"',
] as const;

export const ELVA_FONT_LOAD_TIMEOUT_MS = 2800;
